import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, normalizeLanguageCode } from '../constants/languages';
import LanguageSwitch from '../components/LanguageSwitch';
import './SettingsPage.css';

/**
 * Settings page: language and other preferences (ES/EN).
 */
export default function SettingsPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = normalizeLanguageCode(i18n.language);

  const handleLanguageChange = (code) => {
    const lang = code === 'en' || code === 'es' ? code : 'es';
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
  };

  return (
    <div className="mvp-settings-page">
      <header className="mvp-settings-header">
        <button type="button" className="mvp-settings-back" onClick={() => navigate(-1)}>
          ← {t('back')}
        </button>
        <h1 className="mvp-settings-title">{t('settings.title', 'Settings')}</h1>
        <LanguageSwitch />
      </header>
      <section className="mvp-settings-section" aria-label={t('settings.preferences', 'Preferences')}>
        <h2 className="mvp-settings-section-title">{t('settings.language', 'Language')}</h2>
        <ul className="mvp-settings-list" role="list">
          {LANGUAGES.map((lang) => (
            <li key={lang.code}>
              <button
                type="button"
                className={`mvp-settings-list-item ${lang.code === currentLang ? 'active' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <span className="mvp-settings-list-flag">{lang.flag}</span>
                <span className="mvp-settings-list-label">{lang.name}</span>
                {lang.code === currentLang && (
                  <span className="mvp-settings-list-check" aria-hidden>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </span>
                )}
              </button>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
